export const PRIORITY_EDITOR = 'ignoreKeystrokesWhilePresent'
